export const MARKETPLACE_URL =
  import.meta.env.VITE_MARKETPLACE_URL ?? 'https://marketplace.dev.mydra.io'
export const MARKETPLACE_AI_COURSES_SEARCH_URL =
  import.meta.env.VITE_MARKETPLACE_AI_COURSES_SEARCH_URL ??
  'https://marketplace.dev.mydra.io/search'

export const PRIVACY_POLICY_URL = 'https://www.mydra.io/privacy-policy'
